/* Start Cookie Consent */
document.addEventListener('DOMContentLoaded', function () {
  /*
   * addEventListner: For all major browsers, except IE 8 and earlier
   * attachEvent:     For IE 8 and earlier versions
   */
  let detailLink = document.getElementById("elc-detail-link");
  if (detailLink !== null) {
      if (detailLink.addEventListener) {
          detailLink.addEventListener("click", toggleExpand);
      } else if (detailLink.attachEvent) {
          detailLink.attachEvent("onclick", toggleExpand);
      }
  }

  let hideDetailLink = document.getElementById("elc-hide-detail-link");
  if (hideDetailLink !== null) {
      if (hideDetailLink.addEventListener) {
          hideDetailLink.addEventListener("click", toggleExpand);
      } else if (hideDetailLink.attachEvent) {
          hideDetailLink.attachEvent("onclick", toggleExpand);
      }
  }

  let saveLink = document.getElementById("elc-save-link");
  if (saveLink !== null) {
      if (saveLink.addEventListener) {
          saveLink.addEventListener("click", submitConsent);
      } else if (saveLink.attachEvent) {
          saveLink.attachEvent("onclick", submitConsent);
      }
  }

  let acceptLink = document.getElementById("elc-accept-link");
  if (acceptLink !== null) {
      if (acceptLink.addEventListener) {
          acceptLink.addEventListener("click", submitConsent);
      } else if (acceptLink.attachEvent) {
          acceptLink.attachEvent("onclick", submitConsent);
      }
  }


  let acceptAllLink = document.getElementById("elc-accept-all-link");
  if (acceptAllLink !== null) {
      if (acceptAllLink.addEventListener) {
          acceptAllLink.addEventListener("click", submitAllConsent);
      } else if (acceptAllLink.attachEvent) {
          acceptAllLink.attachEvent("onclick", submitAllConsent);
      }
  }

  let rejectAllLink = document.getElementById("elc-reject-all-link");
  if (rejectAllLink !== null) {
      if (rejectAllLink.addEventListener) {
          rejectAllLink.addEventListener("click", submitNecessaryConsent);
      } else if (rejectAllLink.attachEvent) {
          rejectAllLink.attachEvent("onclick", submitNecessaryConsent);
      }
  }

  let tabLink = document.getElementById("elc-tab-link");
  if (tabLink !== null) {
      if (tabLink.addEventListener) {
          tabLink.addEventListener("click", toggleTab);
      } else if (tabLink.attachEvent) {
          tabLink.attachEvent("onclick", toggleTab);
      }
  }

  addWindowObject()

  // a11y: when the banner is shown on load, move focus to it so keyboard/AT
  // users are aware of it.
  let consentEl = document.getElementById("elc-cookie-consent");
  if (consentEl !== null && !consentEl.classList.contains('elc-hidden')) {
      consentEl.focus();
  }
});

// a11y: after the banner closes, move focus to the reopen tab (if shown) or
// to the main content, so focus is never left on a hidden element.
function moveFocusAfterClose() {
  let tab = document.getElementById("elc-cookie-tab");
  let tabLink = document.getElementById("elc-tab-link");
  if (tab !== null && tabLink !== null && !tab.classList.contains('elc-hidden')) {
      tabLink.focus();
      return;
  }
  let main = document.getElementById("main");
  if (main !== null) {
      main.setAttribute('tabindex', '-1');
      main.focus();
  }
}

function submitConsent(event) {

  event.preventDefault();

  let form = document.querySelector('#elc-cookie-consent-form');
  let data = serialize(form);

  document.getElementById("elc-cookie-consent").classList.toggle('elc-hidden');
  let cookieTab = document.getElementById("elc-cookie-tab");
  if(typeof cookieTab !== 'undefined' && cookieTab !== null) document.getElementById("elc-cookie-tab").classList.toggle('elc-hidden');

  moveFocusAfterClose();

  let xhr = new XMLHttpRequest();
  xhr.open('POST', form.dataset.url);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send(data);

  xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
          addWindowObject()
          if (xhr.status !== 200) console.log('Error: ' + xhr.status);
          else if (form.hasAttribute("data-refresh") && form.dataset.refresh === "true" && form.hasAttribute("data-refreshtime")) {
              refresh(form.dataset.refreshtime)
          }
      }
  }
}

function submitAllConsent(event) {

  event.preventDefault();

  let form = document.querySelector('#elc-cookie-consent-form');

  for (let i = 0; i < form.elements.length; i++ ) {

      if (form.elements[i].type == 'checkbox') {

          if (form.elements[i].checked == false) {
              form.elements[i].checked = true;
          }
      }
  }

  let data = serialize(form);
  document.getElementById("elc-cookie-consent").classList.toggle('elc-hidden');
  let cookieTab = document.getElementById("elc-cookie-tab");
  if(typeof cookieTab !== 'undefined' && cookieTab !== null) document.getElementById("elc-cookie-tab").classList.toggle('elc-hidden');

  moveFocusAfterClose();

  let xhr = new XMLHttpRequest();
  xhr.open('POST', form.dataset.url);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send(data.concat('&acceptAll=true'));

  xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
          if (xhr.status !== 200) console.log('Error: ' + xhr.status);
          else if (form.hasAttribute("data-refresh") && form.dataset.refresh === "true" && form.hasAttribute("data-refreshtime")) {
              refresh(form.dataset.refreshtime)
          }
      }
  }
}

function submitNecessaryConsent(event) {

  event.preventDefault();

  let form = document.querySelector('#elc-cookie-consent-form');

  // Reject everything optional: uncheck all non-required groups (required groups
  // are disabled and handled server-side). serialize() then omits them, so the
  // stored consent covers only essential cookies.
  for (let i = 0; i < form.elements.length; i++) {
      if (form.elements[i].type == 'checkbox' && form.elements[i].disabled == false) {
          form.elements[i].checked = false;
      }
  }

  let data = serialize(form);

  document.getElementById("elc-cookie-consent").classList.toggle('elc-hidden');
  let cookieTab = document.getElementById("elc-cookie-tab");
  if(typeof cookieTab !== 'undefined' && cookieTab !== null) document.getElementById("elc-cookie-tab").classList.toggle('elc-hidden');

  moveFocusAfterClose();

  let xhr = new XMLHttpRequest();
  xhr.open('POST', form.dataset.url);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send(data);

  xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
          addWindowObject()
          if (xhr.status !== 200) console.log('Error: ' + xhr.status);
          else if (form.hasAttribute("data-refresh") && form.dataset.refresh === "true" && form.hasAttribute("data-refreshtime")) {
              refresh(form.dataset.refreshtime)
          }
      }
  }
}

function refresh(ms) {
  setTimeout(function() {
      location.reload();
  }, ms);
}

function toggleExpand(event)
{
  event.preventDefault();
  let consent = document.getElementById("elc-cookie-consent");
  consent.classList.toggle('elc-fullwidth');
  consent.classList.toggle('elc-small');

  // a11y: the toggle that was just activated hides itself in the new state
  // (elc-detail-link is display:none when fullwidth, elc-hide-detail-link when
  // small), which would drop focus to <body>. Move focus to the toggle that is
  // now visible so keyboard focus stays inside the banner.
  let next = consent.classList.contains('elc-fullwidth')
      ? document.getElementById("elc-hide-detail-link")
      : document.getElementById("elc-detail-link");
  if (next !== null) next.focus();
}

function toggleTab(event)
{
  event.preventDefault();
  document.getElementById("elc-cookie-consent").classList.toggle('elc-hidden');
  document.getElementById("elc-cookie-tab").classList.toggle('elc-hidden');

  document.getElementById("elc-cookie-consent").classList.add('elc-fullwidth');
  document.getElementById("elc-cookie-consent").classList.remove('elc-small');
  document.getElementById("elc-cookie-consent").focus();
}

function addWindowObject()
{
  let form = document.querySelector('#elc-cookie-consent-form');
  if (typeof form.dataset.show !== 'undefined')
  {
      let xhr = new XMLHttpRequest();
      xhr.open('GET', form.dataset.show);
      xhr.send();

      xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
              if (xhr.status !== 200) {
                  console.log('Error: ' + xhr.status);
                  window.ccc = {}
              }
              else {
                  if(xhr.response === 'null') {
                      window.ccc = {}
                  }
                  else window.ccc = JSON.parse(xhr.response)
              }
          }
      }
  }
}

/*!
* Serialize all form data into a query string
* (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
* @param  {Node}   form The form to serialize
* @return {String}      The serialized form data
*/
var serialize = function (form) {

  // Setup our serialized data
  var serialized = [];

  // Loop through each field in the form
  for (var i = 0; i < form.elements.length; i++) {

      var field = form.elements[i];

      // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
      if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'button') continue;

      // If a multi-select, get all selections
      if (field.type === 'select-multiple') {
          for (var n = 0; n < field.options.length; n++) {
              if (!field.options[n].selected) continue;
              serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
          }
      }

      // Convert field data to a query string
      else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
          serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
      }
  }

  return serialized.join('&');

};
/* End Cookie Consent */
